interface XIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
}

function XIcon({ size = 36, className = '', onClick = (event) => {}, ...props }: XIconProps) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick} {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <path d='M18.7909 4.70696C19.1815 5.09748 19.1815 5.73064 18.7909 6.12116L6.62032 18.2918C6.2298 18.6823 5.59664 18.6823 5.20612 18.2918C4.8156 17.9013 4.8156 17.2681 5.20612 16.8776L17.3767 4.70696C17.7673 4.31644 18.4004 4.31644 18.7909 4.70696Z' />
        <path d='M5.20794 4.7071C5.59846 4.31658 6.23162 4.31658 6.62214 4.7071L18.7928 16.8777C19.1833 17.2682 19.1833 17.9014 18.7928 18.2919C18.4022 18.6824 17.7691 18.6824 17.3786 18.2919L5.20794 6.1213C4.81742 5.73078 4.81742 5.09762 5.20794 4.7071Z' />
      </svg>
    </span>
  );
}

export default XIcon;
